const theme = {
	palette: {
		primary: {
			//main: '#F5F5F5',
			main: '#404040',
			//contrastText: '#555555',
		},
		secondary: {
			main: '#06a6fc',
		},
		background: {
			paper: '#FAFAFA',
		},
	},
};

export default theme;
